

















































import { Component, Vue } from 'vue-property-decorator';


@Component
export default class SignIn extends Vue {
  public password: string = '';
  public email: string = '';
  public timeout: number = 5000;
  public valid: boolean = false;

  public emailRules = [
    (v: string) => !!v || 'E-mail is required',
    (v: string) => /.+@.+/.test(v) || 'E-mail must be valid',
  ];

  public passwordRules = [
    (v: string) => !!v || 'Password is required',
    (v: string) => v.length >= 6 || 'Password must be greater than 6 characters',
  ];

  get hasErrors() {
    return this.$store.state.errorMessage !== '';
  }

  get errorMessage() {
    return this.$store.state.errorMessage;
  }

  public clearErrors() {
    this.$store.dispatch('clearErrors', {});
  }

  public submit() {
    this.$store.dispatch('userLogin', {
      email: this.email,
      password: this.password,
    });
  }
}
